// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__12mQg","colMin":"styles_colMin__1Wu2o","colCheckbox":"styles_colCheckbox__3RnTR"};